export {
  default as swimplyDuck,
  ReactComponent as SwimplyDuck,
} from '@assets/swimply-duck.svg'    
